import { useCallback } from 'react'
import { useAppDispatch } from 'shared/hooks'

export const OPEN_ACTION = {
	payload: {
		isModalVisible: true
	},
	type: 'IS_MODAL_VISIBLE'
}

export function useOpenContacts() {
	const dispatch = useAppDispatch()

	return useCallback(() => dispatch(OPEN_ACTION), [dispatch])
}
